import { Api } from '../api';
import { createUrl } from '../../helpers/uri-factory';

const url = createUrl('report');

export class Student extends Api {
    constructor(http, config = {}) {
        super(http, url, 'student', config);
    }
}